import { ANIM_CONFIG } from "./anim-utils";

/**
 * reduce-motion.js
 * Logic for how the site handles the reduce motion toggle, browser settings etc.
 */
;(function($, window, document) {

  const preset = window.localStorage.getItem('reduce-motion');

  $('#reduce_motion').on('change', function() {
    
    if ($('#reduce_motion').is(':checked')) {
      toggleReduceMotion(true);
    } else {
      toggleReduceMotion(false);
    }
    
  });

  // Get the setting from the browser config
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (preset || reduceMotion.matches) {
    $('#reduce_motion').prop('checked', true);    
    toggleReduceMotion(true);
  }

  // Set it again after the animations load. 
  if (preset) {
    setTimeout( () => {
      toggleReduceMotion(true);
    }, 1000);
  }

  function setReduceMotion() {
    (<any>window).tms.reduceMotion = true;
    
    $('html').addClass('reduce-motion');
    $('#motion-state').text('OFF');
    window.localStorage.setItem('reduce-motion', 'true');

    document.dispatchEvent(new Event("tms:pause-videos"));

  }


  function toggleReduceMotion(enabled: boolean) {

    if (enabled) {
      (<any>window).tms.reduceMotion = true;
    
      $('html').addClass('reduce-motion');
      $('#motion-state').text('OFF');
      window.localStorage.setItem('reduce-motion', 'true');

      document.dispatchEvent(new Event("tms:pause-videos"));

    } else {
      (<any>window).tms.reduceMotion = false;
      $('html').removeClass('reduce-motion');
      window.localStorage.removeItem('reduce-motion');
      $('#motion-state').text('ON');
    }

    // Event bus
    ANIM_CONFIG.duration = (enabled) ? 0 : 250;

    
    document.dispatchEvent(new CustomEvent('tms:reduce-motion-change', { detail: { enabled } }));
  }


// @ts-ignore
})(jQuery, window, document);

